/*
 * Module for an kbLocaleModal item
 */
define([
  "backbone",
  "underscore",
  "marionette",
  "jquery",
  "messaging/messenger",
  "modules/accountAdmin/kbWizardModal/kbLocales/kbLocalesView",
  "modules/accountAdmin/kbWizardModal/kbLocales/kbLocalesList/kbLocalesListModule",
  "modules/accountAdmin/kbWizardModal/kbLocales/kbLocalesSearch/kbLocalesSearchModule",
  "modules/accountAdmin/kbWizardModal/kbResponseTypeUsage/kbResponseTypeUsageModule",
], function (
  Backbone,
  _,
  Marionette,
  $,
  Messenger,
  KbLocalesView,
  KbLocalesListModule,
  KbLocalesSearchModule,
  KbResponseTypeUsageModule,
) {
  var KbLocalesModule = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "kbLocales";
      this.region = options.region;
      this.editMode = options.editMode;
      this._setUpVents();
    },

    show: function (kb) {
      this.kb = kb;

      this.layout = new KbLocalesView.kbLocalesLayout({
        model: this.kb,
      });

      this.languageList = this.addSubModule(
        new KbLocalesListModule({ region: this.layout.list, editMode: this.editMode }),
      );
      this.languageSearch = this.addSubModule(
        new KbLocalesSearchModule({
          region: this.layout.languageAvailableSearch,
          editMode: this.editMode,
        }),
      );
      this.responseTypeUsage = this.addSubModule(
        new KbResponseTypeUsageModule({
          region: this.layout.responseTypeUsage,
          editMode: this.editMode,
        }),
      );

      this.layout.on(
        "show",
        function () {
          this.languageList.show(kb);
          this.languageSearch.show(kb);
          this.responseTypeUsage.show(kb);
        },
        this,
      );

      this.showRegion(this.layout);
    },

    done: function () {
      Messenger.vent.trigger("close:modal");
      Messenger.vent.trigger("show:kb:profile:responseSettings");
    },

    getKb: function () {
      return this.kb;
    },

    isValid: function (callback, context) {
      if (this.languageList.isEmpty()) {
        this.layout.clearErrors();
        this.layout.languageAddError($.t("admin.kbAdmin.emptyLocaleListError"));
        return false;
      }
      return true;
    },

    _setUpVents: function () {
      // Remove kb's language from list of languages to available to add.  Adds language back to list
      Messenger.vent.on(
        "show:admin:kbProfile:kbLocale:languages:delete",
        function (language) {
          // this.showRegion(this.layout);
          console.log("Deleting Language");
        },
        this,
      );
    },
  });

  return KbLocalesModule;
});
